<div class="cust-height">
  <div class="col-12 md:col-12">
    <p-table
      #dt
      [(selection)]="selectedRows"
      selectionMode="multiple"
      [columns]="listColumns"
      [value]="batchList"
      [rows]="100"
      [paginator]="true"
      responsiveLayout="stack"
      [breakpoint]="'960px'"
      >
      <ng-template pTemplate="caption">
        <span class="header-grid-wrapper">
          <span class="align-right">{{'Mail_Title' | translate}} {{'Tot' | translate}} {{ batchList.length }} {{'Mail_M' | translate}}</span>
        </span>
        <button pButton type="button" icon="icons8-trash-can" class="cust-width p-button-danger right margin"
          [disabled]="disabledDel===true && selectedRows.length === 0"
          pTooltip="{{'Mail_Delete' | translate}}"
          tooltipPosition="left"
          (click)="clickDelMail()"
        ></button>
      </ng-template>
      <ng-template let-columns pTemplate="header">
        <tr>
          <th class="width-col-3">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          @for (col of columns; track col; let i = $index) {
            <th
              [pSortableColumn]="col.sort"
                        [ngClass]="{
                            'width-col-13': col.type === 'DateTime',
                            'width-auto': col.type !== 'DateTime',
                            'width-col-15': col.field === 'status'
                        }"
              >
              @if (col.sort !== null) {
                <p-sortIcon [field]="col.sort"></p-sortIcon>
              }
              {{ col.header }}
              @if (col.field === 'status') {
                <p-dropdown
                  appendTo="body"
                  [options]="stateList"
                  [style]="{ width: '100%' }"
                  (onChange)="dt.filter($event.value, col.field, 'equals')">
                  <ng-template let-stateList pTemplate="item">
                    @if (stateList.value === 'send') {
                      <i pTooltip="{{'Mail_Type_0' | translate}}" class="pi pi-check md-18" style="color: green"></i>
                    }
                    @if (stateList.value === 'queued') {
                      <i pTooltip="{{'Mail_Type_1' | translate}}" class="pi pi-clock md-18" style="color: orange"></i>
                    }
                    @if (stateList.value === 'error') {
                      <i pTooltip="{{'Mail_Type_2' | translate}}" class="pi pi-times md-18" style="color: red"></i>
                    }
                    {{stateList.label}}
                  </ng-template>
                </p-dropdown>
              }
              @if (col.field !== 'status') {
                <input
                  (click)="$event.stopPropagation()"
                  pInputText
                  type="text"
                  (input)="dt.filter($event.target.value, col.field, 'contains')"
                  style="color: darkgrey"
                  />
              }
            </th>
          }
          <th style="width: 3em"></th>
          <th style="width: 3em"></th>
        </tr>
      </ng-template>
      <ng-template let-rowData let-columns="columns" pTemplate="body">
        <tr [pSelectableRow]="rowData">
          <td (click)="clickcolck($event)">
            <p-tableCheckbox [ngClass]="rowData['status'] !== 'queued' ? 'visible-ok' : 'visible-ko'" [value]="rowData" [index]="rowIndex"></p-tableCheckbox>
          </td>
          @for (col of columns; track col; let i = $index) {
            <td class="width-auto">
              @switch (col.field) {
                @case ('created_at') {
                  <div class="align-left">
                    {{ rowData[col.field] | datelength | datecompat | date: 'dd/MM/yyyy HH:mm:ss' }}
                  </div>
                }
                @case ('sent_at') {
                  <div class="align-left">
                    @if (rowData[col.field] !== null) {
                      <span>{{ rowData[col.field] | datelength | datecompat | date: 'dd/MM/yyyy HH:mm:ss' }}</span>
                    }
                  </div>
                }
                @case ('status') {
                  <div class="align">
                    @if (rowData[col.field] === 'send') {
                      <i pTooltip="{{'Mail_Type_0' | translate}}" class="pi pi-check md-18" style="color: green"></i>
                    }
                    @if (rowData[col.field] === 'queued') {
                      <i pTooltip="{{'Mail_Type_1' | translate}}" class="pi pi-clock md-18" style="color: orange"></i>
                    }
                    @if (rowData[col.field] === 'error') {
                      <i pTooltip="{{'Mail_Type_2' | translate}}" class="pi pi-times md-18" style="color: red"></i>
                    }
                  </div>
                }
                @case ('recipients') {
                    {{ getRecipients(rowData[col.field]) }}
                }
                @default {
                    {{ rowData[col.field] }}
                }
              }
            </td>
          }
          <td>
            <button
              class="cust-width p-badge-secondary"
              type="button" pButton
              icon="pi pi-eye"
              pTooltip="{{'Mail_Content' | translate}}"
              (click)="onDetail($event, rowData)"
            ></button>
          </td>
          <td>
            <button
              [ngClass]="rowData['status'] !== 'queued' ? 'visible-ok' : 'visible-ko'"
              class="cust-width p-button-success"
              type="button" pButton
              icon="icons8-envoyer-des-email-de-masse"
              pTooltip="{{'Mail_Send' | translate}}"
              (click)="onSend($event, rowData)"
            ></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="7">{{'Empty' | translate}}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-dialog header="{{messageContent.subject}}" [(visible)]="displayModal" [dismissableMask]="true" [modal]="true" [style]="{width: '50vw'}" [closable]="true">
  <div>
    <p><strong>{{'UsersE' | translate}} </strong>{{messageContent.sender}}</p>
    <p><strong>{{'UsersD' | translate}} </strong>{{getRecipients(messageContent.recipients)}}</p>
  </div>
  <div [innerHTML]="messageContent.message"></div>
</p-dialog>


<app-item-confirm [key]="'delete'" [severity]="'alert'" (onAccept)="delete()"></app-item-confirm>
